import styled from 'styled-components'

import { FlexContainer } from '@/components'

export const FlexContainerStyles = styled(FlexContainer)`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  max-width: 100vw;
`

export const Video = styled.video`
  height: 100%;
  width: 100%;

  cursor: pointer;
`

export const PlayButton = styled.div`
  position: absolute;

  background-color: ${({ theme }) => `${theme.colors.black}b3`};
  border-radius: 50%;

  cursor: pointer;
  outline: none;

  width: 180px;
  height: 180px;

  display: flex;
  align-items: center;
  justify-content: center;

  .play-icon {
    width: 64px;
    height: 64px;
    margin-left: 22px;
    background: ${({ theme }) => theme.colors.white};
    clip-path: polygon(0 0, 80% 50%, 0 100%);
  }
`
